import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [contacts, setContacts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [analytics, setAnalytics] = useState({
    totalContacts: 0,
    totalTasks: 0,
  });

  const addContact = (contact) => {
    setContacts([...contacts, { id: Date.now(), ...contact }]);
    setAnalytics((prev) => ({
      ...prev,
      totalContacts: prev.totalContacts + 1,
    }));
  };

  const deleteContact = (id) => {
    setContacts(contacts.filter((contact) => contact.id !== id));
    setAnalytics((prev) => ({
      ...prev,
      totalContacts: prev.totalContacts - 1,
    }));
  };

  const addTask = (task) => {
    setTasks([...tasks, { id: Date.now(), createdAt: new Date(), ...task }]);
    setAnalytics((prev) => ({ ...prev, totalTasks: prev.totalTasks + 1 }));
  };

  const deleteTask = (id) => {
    setTasks(tasks.filter((task) => task.id !== id));
    setAnalytics((prev) => ({ ...prev, totalTasks: prev.totalTasks - 1 }));
  };

  return (
    <AppContext.Provider
      value={{
        contacts,
        analytics,
        addContact,
        deleteContact,
        tasks,
        addTask,
        deleteTask,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
